import { SupportedLocales } from "config";
import {
    IGetAuthorizationResponse,
    IPostAgreementsResponse,
    IPostAuthorizationResponse,
    IPostRegistrationResponse,
    IPutRegistrationResponse,
    IStatusResponse
} from "types/ichAppServices";
import { ITypedAPITarget } from "./NetworkStapler";

export function getStatus(): ITypedAPITarget<IStatusResponse> {
    return {
        url: "/ichapp/rest/status",
        headers: {
            "Accept": "application/json"
        },
        method: "GET",
        parse: json => json as IStatusResponse
    };
}

export function postRegistration(body: { email: string, language: SupportedLocales }): ITypedAPITarget<IPostRegistrationResponse> {
    return {
        url: "/ichapp/rest/registrations",
        headers: {
            "Accept": "application/json"
        },
        body,
        method: "POST",
        parse: json => json as IPostRegistrationResponse
    };
}

export function putRegistration(body: { eId: string, otp: string }): ITypedAPITarget<IPutRegistrationResponse> {
    return {
        url: "/ichapp/rest/registrations",
        headers: {
            "Accept": "application/json"
        },
        body,
        method: "PUT",
        parse: json => json as IPutRegistrationResponse
    };
}

export function postResendValidationCode(body: { email: string, language: SupportedLocales, eId: string }): ITypedAPITarget<IPostRegistrationResponse> {
    return {
        url: "/ichapp/rest/validation-code",
        headers: {
            "Accept": "application/json"
        },
        body,
        method: "POST",
        parse: json => json as IPostRegistrationResponse
    };
}

export function postAgreements(): ITypedAPITarget<IPostAgreementsResponse> {
    return {
        url: "/ichapp/rest/agreements",
        headers: {
            "Accept": "application/json"
        },
        method: "POST",
        parse: json => json as IPostAgreementsResponse
    };
}

export function postAuthorization(eId: string): ITypedAPITarget<IPostAuthorizationResponse> {
    return {
        url: "/ichapp/rest/authorizations",
        headers: {
            "Accept": "application/json"
        },
        body: { eId },
        method: "POST",
        parse: json => json as IPostAuthorizationResponse
    };
}

// Polling for authorization status
export function getAuthorization(authorizationId: string): ITypedAPITarget<IGetAuthorizationResponse> {
    return {
        url: `/ichapp/rest/authorizations/${authorizationId}`,
        headers: {
            "Accept": "application/json"
        },
        method: "GET",
        parse: json => json as IGetAuthorizationResponse
    };
}

export function postDeregistration(): ITypedAPITarget<IPostAuthorizationResponse> {
    return {
        url: "/ichapp/rest/deregistrations",
        headers: {
            "Accept": "application/json"
        },
        method: "POST",
        parse: json => json as IPostAuthorizationResponse
    };
}

// Polling for deregistration status
export function getDeregistration(authorizationId: string): ITypedAPITarget<IGetAuthorizationResponse> {
    return {
        url: `/ichapp/rest/deregistrations/authorizations/${authorizationId}`,
        headers: {
            "Accept": "application/json"
        },
        method: "GET",
        parse: json => json as IGetAuthorizationResponse
    };
}




// WEBPACK FOOTER //
// ./src/network/IchAppAPI.ts